import "@fortawesome/fontawesome-free/js/all";

require("datatables.net-bs5");
global.Blockly = require("blockly");
global.bootstrap = require("bootstrap");
global.jQuery = require("jquery");
global.$ = require("jquery");
require("jquery-ui/dist/jquery-ui");
global.Handlebars = require("handlebars");
global.toastr = require("toastr");
global.svgPanZoom = require("svg-pan-zoom");
global.SVG = require("@svgdotjs/svg.js");

import select2 from "select2";
select2();
const dropdownElementList = document.querySelectorAll(".dropdown-toggle");
const dropdownList = [...dropdownElementList].map(
    (dropdownToggleEl) => new bootstrap.Dropdown(dropdownToggleEl)
);
$("select").select2({
    placeholder: "Please select",
    theme: "bootstrap-5",
    allowClear: true,
});
